////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:  Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130. Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import Iframe from 'react-iframe'
import { Step, Stepper } from '@cimpress/react-components';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios'
import generatePdf from './pdfprocessing.js'

const checkmarkIcon = '✓';

class Review extends Component {
  state = {
    submitting: false,
    verticalActiveStep: 0,
    showFinalReviewModal: false,
    appendixBytes: null
  };


 setVerticalStep = index => {
  if (index < 3){
    this.modifyState({ verticalActiveStep: index })
    return
  }
  this.setState({ verticalActiveStep: index });
 };

 componentDidMount() {
  if (this.props.getPageState("Review")){
    this.setState(this.props.getPageState("Review"));
    return;
  }
 }


 componentWillMount() {
    const config = { headers: { 'content-type': 'application/json' } }
    const selected_freqs = this.props.allPageStates.MapSelection.selected_freqs;
    let [minlat, minlong, maxlat, maxlong] = [90,90, -90, -90]
    for (let s of this.props.allPageStates.MapSelection.selectedNetworkAreas){
        for (let p of s){
            if (p.lat < minlat){
                minlat = p.lat
            }
            if (p.lng < minlong){
                minlong = p.lng
            }
            if (p.lat > maxlat){
                maxlat = p.lat
            }
            if (p.lng > maxlong){
                maxlong = p.lng
            }
        }
    }
    axios.get(`${process.env.REACT_APP_LAL_ENDPOINT}/mno_measurements/${maxlat}/${maxlong}/${minlat}/${minlong}/${selected_freqs[0].toFixed(1)}/${selected_freqs[1].toFixed(1)}/9`)
      .then(response => {
        let tabledata = {}

        for (let f of response.data.features){
            let dataset = `${f.properties.entity_name} ${f.properties.technology}`
            if (!tabledata.hasOwnProperty(dataset)){
                tabledata[dataset] = {0:0, 1:0, 2:0,3:0}
            }
            tabledata[dataset][f.properties.service_level]++
            
        }
        axios({
            url: `${this.props.SERVER_URLS.api}/PDF/${this.props.requestID}`,
            method: 'PUT',
            responseType: 'blob',
            data:{"user_id":localStorage.getItem("user_id"), 'tabledata': tabledata}
          }).then( async (response) => {
            response.data.arrayBuffer().then(async (appendixBytes)=>{
                this.setState({
                    appendixBytes: appendixBytes
                })
    
                //const pdfBytes = await pdfDoc.save()
                //FileDownload(pdfBytes, 'appendix.pdf');
            }
            )
    
          });      })
      .finally(() => {
        this.setState({havePolygonsLoaded: true})
      });
    let URL = `${this.props.SERVER_URLS.api}/configureprofile`
    axios.put(URL, {"user_id":localStorage.getItem("user_id")}, config)
      .then(response =>{
        this.setState({
            userInfo: response.data.user_info
        })
        })
      .catch(
        function(error) {
          console.log(
          error
        )
      })

}

getBase64 = file => {
    return new Promise(resolve => {
    let fileInfo;
    let baseURL = "";
    // Make new FileReader
    let reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(file);

    // on reader load somthing...
    reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        //console.log(baseURL);
        resolve(baseURL);
    };
    });
};



 uploadFile = (e) => {
  let filelist = this.state.files
  let file = e.target.files[0];

  this.getBase64(file)
  .then(result => {
      this.props.savePDF(result)
      this.setVerticalStep(2)
  })
  .catch(err => {
      console.log(err);
  });
 }
 renderError = ({ meta: { touched, error } }) =>
  touched && 
  error ? <span>{error}</span> : false

 modifyState = (state, callback) => {
  this.setState(state, callback);
  this.props.updatePageState("Review", state);
  }

  handleSubmit = () => {
    this.setState({ submitting: false})

    this.props.onSubmit().catch(() => {
      this.setState({ submitting: false });
    })
  };

 render(){
  return (
  <React.Fragment>
    <Modal
      show={this.state.showFinalReviewModal}
      onHide={() => {
        this.setState({showFinalReviewModal: false})
      }}
      dialogClassName="modal-dialog modal-lg"
      aria-labelledby="review-modal"
      style={{maxWidth: "90vw", width: '90vw'}}>
      <Modal.Header closeButton>
        <Modal.Title id="review-modal">Final Review and Submission</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <center>
          <h4>Step 7: Review and Submit</h4>
          <Iframe url={`${this.props.SERVER_URLS.api}/PDF/${this.props.requestID}?requesttime=${Date.now()}`}
                  width="80%"
                  height="650px"
                  id="myId"
                  className="myClassname"
                  display="initial"
                  position="relative"/>
        </center>

        <br/>
      </Modal.Body>
      <Modal.Footer>
        <div className="button-row">
          <Button variant="light" disabled={this.state.submitting} onClick={() => this.setState({showFinalReviewModal: false})}>
            Exit
          </Button>
          <Button variant="primary" disabled={this.state.submitting} onClick={this.handleSubmit}>
            Submit to Ofcom
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
   <div>
    {/*<Stepper activeStep={this.state.activeStep}>
     <Step onClick={this.setStep}>
      <div>Step One</div>
      <small>A step</small>
     </Step>
     <Step onClick={this.setStep}>
      <div>Step Two</div>
      <small>It's another step!</small>
     </Step>
     <Step onClick={this.setStep} tip="Lorem ipsum tipsum">
      <div>Step Three</div>
      <small>A third step</small>
     </Step>
  </Stepper>*/}

     <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '10px'}}>
       <div>
         <h3>Final review, signature, and application submission</h3>
         <p>You may now download a pdf of an Ofcom OfW588 form which is pre-completed with the answers you have
           provided.</p>
         <p>The precompleted form must be downloaded, signed, and re-uploaded before it can be submitted to Ofcom</p>
         <p>
           By clicking on the 'Download' button below, you are providing your specific
           consent for:
           <ul>
             <li>
               <a href="https://www.federatedwireless.com/" target="_blank">Federated Wireless</a> to share your Local Access
               License Application data with Ofcom for the purpose of providing you with spectrum access.
             </li>
             <li>
               Ofcom to share data and correspondence related to Local Access License Application
               with <a href="https://www.federatedwireless.com/" target="_blank">Federated Wireless</a> via a unique email
               ID auto-generated for this Application.
             </li>
           </ul>
         </p>
         <p>
           You have the right to withdraw consent in some circumstances. To exercise this right and/ or for
           further details regarding how <a href="https://www.federatedwireless.com/" target="_blank">Federated Wireless</a> manage
           your personal data please refer to our privacy notice.
         </p>
      <div style={{ height: '500px' }}>
       <Stepper icon={checkmarkIcon} activeStep={this.state.verticalActiveStep} vertical>
        <Step icon={checkmarkIcon} onClick={this.setVerticalStep}>
         <div>Download precompleted licensing form PDF</div>
         <button type="button" disabled={!this.state.appendixBytes} className="btn btn-primary" onClick={async ()=>{
          const URL = `${this.props.SERVER_URLS.api}/PDF/${this.props.requestID}`

          axios({
            url: URL,
            method: 'POST',
            responseType: 'blob',
            data:{"user_id":localStorage.getItem("user_id")}
          }).then( async (response) => {
            response.data.arrayBuffer().then(async (existingPdfBytes)=>{
                generatePdf(
                    existingPdfBytes, 
                    this.state.userInfo,
                    this.props.requestID,
                    this.props.getPageState("ProjectOverview"), 
                    this.props.getPageState("MapSelection"),
                    this.props.getPageState("TransmittingStations"),
                    this.props.getPageState("AnalysisDetails"),
                    this.props.getPageState("MNOConsultation"),
                    this.state.appendixBytes)
                this.setVerticalStep(1)
            }
            )

          });

          }} size="lg" style={{right:"100px", position:"absolute"}}>Download</button>
         <small>Download the precompleted PDF to make any additional changes and sign it<br /><b>Note: Checkbox values may be modifed only by editing <br />values via this toolkit and regenerating PDF</b></small>

        </Step>

        <Step icon={checkmarkIcon} onClick={this.setVerticalStep}>
         <div>Upload fully completed and signed PDF</div>
         { this.state.verticalActiveStep === 1 && <React.Fragment>
         <small>Upload fully completed and signed PDF with any final changes made</small>  
         <form>
          <div>
         <input type="file" accept=".pdf" onChange={this.uploadFile} style={{right:"200px", position:"absolute"}} /></div>
         </form></React.Fragment>}

        </Step>
        <Step icon={checkmarkIcon}>
         <div>Confirm you have read and understood</div>
         { this.state.verticalActiveStep === 2 && <React.Fragment>
         <small>
          <ul>
            <li>The need to inform any customers of the service, provided over the frequencies authorised by the Local Access Licence, of the time limited nature of the access to the spectrum</li>
            <li>The requirement to pay a one-off fee directly to Ofcom (i.e. not via the Toolkit)</li>
            <li>Ofcom’s right to access and inspect the radio equipment</li>
            <li>A link to the terms of the licence</li>
            <li>The need for agreement with the incumbent MNO for LALs with duration beyond three years</li>
            <li>The equipment must be used at all times in accordance with the terms of the licence, and the consequences for failing to do so</li>
            <li>That any changes that would impact on the spectrum rights set out in the licence (e.g. equipment details, location, usage etc.) can only be done with Ofcom’s approval, and that a change from the details shown in the licence made without prior approval from Ofcom may mean that operation of the equipment would be illegal</li>
            <li>That licences cannot be renewed and must be re-applied, and that transmissions must cease if the original licence ends before re-approval has completed</li>
            <li>The need to allow Ofcom to instruct them to provide access to, modify or shut down their equipment</li>
            <li>The in-block and out-of-block power limits</li>
            <li>The need for TDD networks to synchronise with other users or use a restricted transmission mask.</li>
          </ul>
         </small>
         <form>
          <div>
           I have read and understood the above points: <input type="checkbox" onChange={ (e) => {this.setVerticalStep(3)}} />
          </div>
         </form></React.Fragment>}

        </Step>
        {/*<StepGroup onClick={this.setVerticalStep} tip="Lorem ipsum tipsum" contents={<div>Step Three</div>}>
         <Step overrideStatus="danger" tip="This step causes Step Three to inherit the danger color" onClick={this.setVerticalStep}>
          <div>Sub-step one</div>
         </Step>
         <Step overrideStatus="warning" onClick={this.setVerticalStep}>
          <div>Sub-step two</div>
         </Step>
         <Step onClick={this.setVerticalStep}>
          <div>Sub-step three</div>
         </Step>
</StepGroup>*/}

        <Step icon={checkmarkIcon} >
         <div>Final review before submission</div>
         { this.state.verticalActiveStep === 3 && <React.Fragment>
         <small>Final review of document before submission to Ofcom</small>
         <Button variant="primary" onClick={()=>{
          this.setState({showFinalReviewModal: true})

          }} size="lg" style={{right:"100px", position:"absolute"}} >Final Review</Button>
         </React.Fragment>}

        </Step>
       </Stepper>
      </div>
     </div>
    </div>
   </div>

     <div className="button-row">
     <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={this.props.previousPage}>
      Previous Page
     </button>
      <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={()=>{
        this.props.saveAndExit()
        }}>
      Save and Exit
      </button>
     </div>

   </React.Fragment>
  );
 };

}

export default Review;
